import { api } from './api'

export const settingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    createCertification: build.mutation<any, any>({
      query(body) {
        return {
          url: `/certifications`,
          method: 'POST',
          body
        }
      }
    }),
    updateCertification: build.mutation<any, { certificationId: string; body: Partial<any> }>({
      query: ({ certificationId, body }) => ({
        url: `/certifications/${certificationId}`,
        method: 'PUT',
        body,
      }),
    }),
  })
})

export const {
  useCreateCertificationMutation,
  useUpdateCertificationMutation,
} = settingsApi
